<template>
  <main class="home">
    <section class="kk-banner-warp" ref="banner" :style="{ transform: `translateY(${translateTop}px)` }">
      <div class="kk-banner">
        <div ref="bannerTitle" class="kk-banner-content animate__animated animate__fadeIn">
          <!--          <div class="kk-banner-content__title">-->
          <!--            {{ currentHeadline.title }}-->
          <!--          </div>-->
          <!--          <div ref="subTitle" class="kk-banner-content__sub-title">-->
          <!--            学子为先 知行合一 利他而为-->
          <!--          </div>-->
        </div>
        <video ref="video" src="https://kuke-utils.kuke99.com/common/img/kk-website/video/banner1_zimu.mp4"
          poster="@/assets/images/index/banner.png" preload="metadata" webkit-playsinline="true" style="
            object-fit: cover;
            object-position: 50% 60%;
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0px;
            top: 0px;
            z-index: 6;
          " loop autoplay playsinline muted="false"></video>
      </div>
    </section>
    <section class="kk-news-wap total-width">
      <div class="kk-news">
        <div class="kk-news-title" :style="{
          opacity: headerOpacity,
        }">
          新闻资讯
        </div>
        <div class="kk-news-containe">
          <template v-for="(item, index) in newsData">
            <a v-if="index < 5" class="kk-news-containe-item" :key="item.id" @click.stop="handleClick(item)">
              <div class="kk-news-containe-item__image">
                <img :src="item.picture" alt="" />
              </div>
              <div class="kk-news-containe-item__info">
                <div class="kk-news-containe-item__info-title">
                  {{ item.title }}
                </div>
                <div class="kk-news-containe-item__info-button">
                  <p>查看详情</p>
                  <img src="@/assets/images/index/arrow_r_blak.webp" alt="" />
                </div>
              </div>
            </a>
          </template>
        </div>
        <a class="kk-news-button" @click.stop="handleRouterLink">
          <p>查看更多新闻</p>
          <img src="@/assets/images/index/arrow_r_blak.webp" alt="" />
        </a>
      </div>
    </section>
    <section class="kk-industrial">
      <div class="kk-industrial-title">产业布局</div>
      <div class="kk-industrial-tab total-width">
        <ul>
          <li v-for="item in product.pList" :key="item.id" @click="selectHandle(item.id)">
            <img :class="{ imgActive: cId === item.id }" :src="item.icon" :alt="item.title" />
            <p :class="{ textActive: cId === item.id }">{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <div class="kk-industrial-details">
        <img :src="currentImg" alt="" />
        <div class="kk-industrial-details__left">
          <transition name="slide">
            <div class="kk-industrial-details__left-describe" v-if="cId === cData.id">
              <h3>{{ cData.title }}</h3>
              <p>
                {{ cData.content }}
              </p>
              <div class="kk-industrial-details__left-describe-line"></div>
            </div>
          </transition>
        </div>
      </div>
    </section>
    <section>
      <div class="kk-partner">
        <div class="kk-partner-title">战略合作伙伴</div>
        <ul class="double-width">
          <li class="img-width" v-for="(item, index) of partner" :key="index">
            <img :src="item" alt />
          </li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import { indexData } from '@/common/util/data.js'
import { getIndexNewsList } from '@/api/news'
export default {
  name: 'Index',
  metaInfo: metaInfo.Index,
  props: {
    top: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    currentHeadline() {
      if (this.timeDisplay === -1) return { title: '', desc: '' }
      return this.headline[this.timeDisplay]
    },
  },
  watch: {
    top(val) {
      const height = this.getVideoHeight()
      const b = (height - 188) / height
      const magnification = this.scrollMagnification.get(b.toFixed(1))
      this.translateTop = -val / magnification
      this.headerOpacity = (val - height / 3) / 150
    },
  },
  data() {
    return {
      ...indexData,
      cData: indexData.product.pList[0],
      cId: 1,
      sActive: true,
      eId: 1,
      oId: 1,
      currentImg: indexData.product.pList[0].bgImg,
      hId: 1,
      newsData: [],
      // 当前播放的位置
      timeDisplay: 0,
      currentTime: 0,
      // 视频的偏移量
      translateTop: 0,
      // 新闻中心名称的字体
      headerOpacity: 0,
      headline: [
        {
          title: '为天下学子成就美好人生',
          desc: `学子为先 知行合一 利他而为`,
        },
        {
          title: '中国职业教育隐形冠军',
          desc: `专注职教细分赛道 科技推动教育发展`,
        },
        {
          title: 'OMO生态闭环模式',
          desc: `在线教育+线下培训+教辅图书三位一体`,
        },
        {
          title: '企业发展125战略',
          desc: `
                    一支库课铁军<br/>
                以学员为中心、以产品为核心<br/>
          匠心打造1本好书、1套好题、1堂好课、1个好品牌、1个好平台
          `,
        },
      ],
      // 滚动倍率
      scrollMagnification: new Map([
        ['0.9', 3.8],
        ['0.7', 2.6],
        ['0.6', 1.6],
        ['0.5', 1.2],
        ['0.8', 3.2],
      ]),
    }
  },
  mounted() {
    // 获取到视频的在当前屏幕的高度
    this.$nextTick(() => {
      const video = this.$refs.video
      video.addEventListener('timeupdate', this.recordPlayingTime)
    })
  },
  created() {
    this.getNewsList()
  },
  methods: {
    selectHandle(id) {
      this.cId = id
      setTimeout(() => {
        this.cData = this.product.pList.find((item) => item.id === id)
        this.currentImg = this.cData.bgImg
      }, 200)
    },
    // 记录当前播放的时间更新对应的标题
    recordPlayingTime() {
      // 注册视频播放的监听器
      const video = this.$refs.video
      if (!video || !video.currentTime) return
      const currentTime = Math.floor(video.currentTime)
      if (currentTime === this.currentTime) return

      this.currentTime = currentTime

      // 注：文字需要在 7 或 8 秒后更换, 产品给的视频长度取余后没有规律
      // 因此使用最笨的方式
      const value = [7, 14, 22, 0]
      if (value.includes(currentTime)) {
        const dom = this.$refs.bannerTitle
        dom.classList.remove('animate__fadeIn')
        dom.classList.add('animate__fadeOut')
        setTimeout(() => {
          this.timeDisplay++
          // 重置当前显示内容的索引
          if (!currentTime) this.timeDisplay = 0
          this.$refs.subTitle.innerHTML = this.headline[this.timeDisplay].desc
          dom.classList.add('animate__fadeIn')
          dom.classList.remove('animate__fadeOut')
        }, 1000)
      }
    },
    getVideoHeight() {
      return (
        (this.$refs && this.$refs.banner && this.$refs.banner.offsetHeight) || 0
      )
    },
    // 获取首页的资讯列表
    async getNewsList() {
      const { data } = await getIndexNewsList()
      this.newsData = data.list
    },
    // 路由到资讯详情页
    handleClick(data) {
      this.$router.push(`/news/${data.id}`)
    },
    // 路由到资讯列表页
    handleRouterLink() {
      this.$router.push(`/news`)
    },
  },
}
</script>

<style scoped lang="less">
.home {
  position: relative;
  margin: 0 auto;
  text-align: center;
  background: #f7f7f7;

  .kk-banner-warp {
    height: 100vh;
    width: 100%;

    .kk-banner {
      position: relative;
      height: 100%;
      width: 100%;

      &-content {
        position: absolute;
        text-align: center;
        top: 50%;
        width: 100%;
        z-index: 20;
        transform: translateY(-50%);

        &__title {
          color: #fff;
          font-size: 3.9rem;
          font-weight: 800;
          margin-bottom: 0.3125rem;
        }

        &__sub-title {
          color: #fff;
          font-size: 2.1rem;
          letter-spacing: 3px;
        }
      }
    }
  }

  .kk-news-wap {
    position: relative;
    height: 1460px;
    z-index: 10;

    .kk-news-bg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 500px;
      background: #f1f1f1;
    }

    .kk-news {
      position: relative;
      top: -8.6rem;

      &-title {
        padding-bottom: 60px;
        font-size: 48px;
        font-weight: 600;
        color: #333333;
        line-height: 48px;
      }

      &-containe {
        display: grid;
        margin: 0 auto;
        padding-bottom: 40px;
        grid-template-columns: repeat(3, 32.22%);
        grid-template-rows: repeat(2, 620px);
        grid-row-gap: 20px;
        grid-column-gap: 20px;

        &-item {
          display: flex;
          flex-direction: column;
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          cursor: pointer;

          &__image {
            width: 100%;
            height: 310px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              transition: all 0.4s;
              object-fit: cover;
            }
          }

          &__info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            padding: 40px;
            color: #333333;
            transition: all 0.4s;

            &-title {
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              font-size: 24px;
              font-weight: 600;
              line-height: 36px;
              text-align: left;
            }

            &-button {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 72px;
              box-shadow: inset 0px 1px 0px 0px #dddddd;

              p {
                font-size: 16px;
                font-weight: 400;
              }

              img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }

        &-item:first-child {
          grid-column-start: span 2;

          .kk-news-containe-item__image {
            height: 444px;
          }

          .kk-news-containe-item__info {
            background: #e62129;
            color: #fff;

            &-button {
              box-shadow: none;

              img {
                filter: brightness(0) invert(1);
              }
            }
          }
        }

        &-item:first-child:hover {
          .kk-news-containe-item__image {
            img {
              transform: scale(1.05);
            }
          }
        }

        &-item:not(:first-child):hover {
          .kk-news-containe-item__image {
            img {
              transform: scale(1.05);
            }
          }

          .kk-news-containe-item__info {
            background: #e62129;
            color: #fff;

            &-button {
              box-shadow: inset 0px 1px 0px 0px #fff;

              img {
                filter: brightness(0) invert(1);
              }
            }
          }
        }
      }

      &-button {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        background: #ffffff;
        border-radius: 12px;
        cursor: pointer;

        p {
          font-size: 24px;
          font-weight: 400;
          color: #111111;
          letter-spacing: 1px;
        }

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .kk-industrial {
    background: #fff;

    &-title {
      font-size: 48px;
      font-weight: 600;
      color: #333333;
      padding: 80px 0 60px 0;
    }

    &-tab {
      ul {
        display: flex;
        justify-content: space-between;

        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 288px;
          padding: 66px 0 40px 0;
          cursor: pointer;

          img {
            position: absolute;
            box-sizing: border-box;
            pointer-events: none;
            top: 4px;
            transform-origin: 50% 100%;
            opacity: 1;
            width: 48px;
            height: 48px;
            border-radius: 0px;
            background-color: rgba(255, 255, 255, 0);
            transform: translate(-0.5px, 0px);
            transition: all 0.2s;
          }

          p {
            font-size: 24px;
            font-weight: 500;
            color: #333333;
          }

          .imgActive {
            top: -16px;
            opacity: 1;
            width: 72px;
            height: 72px;
          }

          .textActive {
            color: #e62129;
          }
        }
      }
    }

    &-details {
      position: relative;

      img {
        width: 100%;
        height: 540px;
      }

      &__left {
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        background: rgba(0, 0, 0, 0.71);

        &-describe {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          justify-content: center;
          padding: 0 8.6% 0 17.8%;
          height: 100%;
          color: #fff;

          h3 {
            font-size: 32px;
            font-weight: bold;
            padding-bottom: 40px;
          }

          p {
            font-size: 16px;
            font-weight: 400;
            text-align: left;
          }

          &-line {
            margin-top: 74px;
            width: 40px;
            height: 4px;
            background: #e62129;
          }
        }
      }
    }
  }

  .kk-partner {
    padding: 0 0 120px;
    margin: auto;
    overflow: hidden;

    &-title {
      padding-top: 80px;
      font-size: 48px;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
      letter-spacing: 2px;
    }

    ul {
      animation: move 100s linear infinite;
      margin-top: 60px;

      li {
        float: left;

        img {
          width: 100%;
          height: auto;
        }
      }

      li+li {
        padding-left: 20px;
      }
    }

    @keyframes move {
      from {
        transform: translateX(0%);
      }

      to {
        transform: translateX(-50%);
      }
    }
  }
}
</style>
